import { render, staticRenderFns } from "./DownloadExpiredDataModal.vue?vue&type=template&id=4fd2f070&"
import script from "./DownloadExpiredDataModal.vue?vue&type=script&lang=js&"
export * from "./DownloadExpiredDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports